import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
export const Title = styled((props) => (
  <Typography component="h1" {...props} />
))(({ theme }) => ({
  margin: "20px 0",
  fontSize: "28px",
  fontFamily: "Poppins",
  fontWeight: 700,
  textAlign: "center",

  [theme.breakpoints.down("md")]: {
    fontSize: "26px",
  },
}));
export const QuestionFooter = styled(Typography)(({ theme }) => ({
  flexDirection: "row",
  padding: "0 2%",
  marginBottom: "20px",
  display: "flex",
  rowGap: 2,
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));
export const BtnNext = styled(Button)(({ theme }) => ({
  width: "150px",
  height: "51px",
  background: "#27b1bb !important",
  textTransform: "none",
  fontFamily: "Poppins",
  textAlign: "center",
  fontSize: "20px",
  color: "white",
  "&:disabled": { background: "#D9D9D9 !important" },
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    padding: "6px 10px",
    width: "120px",
  },
}));
export const BtnBuy = styled(Button)(({ theme }) => ({
  textTransform: "none",
  color: "black",
  position: "fixed",
  top: "calc(100px + 0.2rem)",
  right: "0",
  fontFamily: "Poppins",
  fontSize: "18px",
  background: "#FFD500 !important",
  zIndex: "997",
  padding: "6px 12px",
  borderRadius: "10px 0px 0px 10px",
  [theme.breakpoints.down("md")]: {
    fontSize: "15px",
    top: "calc(77px + 4.2rem)",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));
export const ItemBox = styled(Box)(({ theme }) => ({
  height: "60px",
  color: "#27B1BB",
  fontSize: "25px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));
export const QuestionBox = styled(Box)(({ theme }) => ({
  border: "2px solid #27B1BB",
  borderRadius: "10px",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  maxWidth: "260px",
  maxHeight: "200px",
  "&:hover": { broder: "2px solid #27B1BB !important" },
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
  },
}));
export const OptionHead = styled(Box)(({ theme }) => ({
  minHeight: "41px",
  minWidth: "50px",
  borderRadius: "4px 4px 0px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#D9D9D9",
  "&:hover": { background: "#27B1BB", color: "white" },
  [theme.breakpoints.down("md")]: {
    borderRadius: "4px 0 0 4px",
  },
}));
export const OptionCircle = styled(Box)(({ theme }) => ({
  width: "39px ",
  height: "39px",
  background: "#FFFFFF",
  borderRadius: "100px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    width: "30px ",
    height: "30px",
  },
}));
export const OptionBody = styled(Box)(({ theme }) => ({
  width: "fit-content",
  minHeight: "88px",
  padding: "0 2%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "auto",
  fontFamily: "Inter",
  [theme.breakpoints.down("md")]: {
    minHeight: "40px",
    padding: "0px",
    paddingLeft: "10px",
  },
}));
export const QuestionHead = styled(Box)({
  minHeight: "40px",
  borderRadius: "5px 5px 0 0",
  display: "grid",
  gridTemplateColumns: "75% 25%", // fix for mark for review
  alignItems: "center",
  justifyContent: "space-between",
  paddingLeft: "20px",
});
export const DetailsBox = styled(Box)({
  borderRadius: "10px",
  marginTop: "2rem",
  border: "2px solid #27B1BB",
  display: "flex",
  background: "#27B1BB",
});
export const SubjectBox = styled(Box)({
  minHeight: "51px",
  background: "#D9D9D9",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "0 2%",
  marginBottom: "10px",
});
export const AnswerBox = styled(Box)({
  margin: "2%",
  background: "#FFFFFF",
  border: "2px solid #1EDA00",
  borderRadius: "10px",
});
export const OptionsList = styled(Box)({
  display: "grid",
  gap: 2,
  margin: "2%",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
});
export const CountBox = styled(Box)({
  height: "34px",
  width: "43px",
  background: "#FFFFFF",
  borderRadius: "5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
export const IncreaseBox = styled(Stack)({
  // height: "100px",
  padding: "10px",
  justifyContent: "space-evenly",
  background: "#F5F6FA",
  borderRadius: "10px",
});

export const CommentBox = styled(Box)({
  background: "#EBEBEB",
  borderRadius: "8px",
  // minHeight: "167px",
  maxWidth: "730px",
  display: "flex",
});
export const IconBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#A4BDBF",
  borderRadius: "5px",
  height: "19px",
  width: "21px",
});

export const StarsBox = styled(Box)(({ theme }) => ({
  height: "51px",
  background: "#27B1BB",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 10px",
  [theme.breakpoints.down("md")]: {
    padding: "0 5px",
    width: "180px",
    fontSize: "12px",
  },
}));
